var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccountingDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41 45C41 45.5304 40.7893 46.0392 40.4142 46.4142C40.0391 46.7893 39.5304 47 39 47H9C8.46957 47 7.96086 46.7893 7.58579 46.4142C7.21071 46.0392 7 45.5304 7 45V3.00001C7 2.46957 7.21071 1.96087 7.58579 1.58579C7.96086 1.21072 8.46957 1.00001 9 1.00001H28.18C28.4436 0.999274 28.7048 1.05067 28.9485 1.15124C29.1922 1.25181 29.4136 1.39956 29.6 1.58601L40.428 12.414C40.8031 12.789 41.0139 13.2976 41.014 13.828L41 45Z",
    fill: "#040C1E",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.008 11V9",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 11H15.942C15.3189 11.0004 14.7153 11.2177 14.2348 11.6145C13.7544 12.0113 13.4269 12.5629 13.3087 13.1747C13.1904 13.7865 13.2887 14.4204 13.5867 14.9676C13.8848 15.5149 14.3639 15.9414 14.942 16.174L19.07 17.826C19.6481 18.0586 20.1273 18.4851 20.4253 19.0324C20.7233 19.5796 20.8216 20.2135 20.7034 20.8253C20.5851 21.4371 20.2577 21.9887 19.7772 22.3855C19.2967 22.7823 18.6932 22.9996 18.07 23H14",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.008 25V23",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29 1.17999V11C29 11.5304 29.2107 12.0391 29.5858 12.4142C29.9609 12.7893 30.4696 13 31 13H40.82",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.174 33H35.008",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25.04 27H35.008",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M29.008 21H35.008",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13.174 39H35.008",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountingDocument);
export default __webpack_public_path__ + "static/media/AccountingDocument.8ae487e1840e508947837226d190f545.svg";
export { ForwardRef as ReactComponent };